module.exports = __webpack_public_path__ + "static/img/u70064.ac20bf54.png";